skrilla.controller('createLoLDailyContestCtrl', function ($scope, searchService, queryService, paginationService, cacheService, lolContestService, contestsService, modalService) {
    $scope.selectedMatches = [];
    $scope.selectedPlaceholders = [];

    cacheService.registerObject("contestSport", "lol");
    cacheService.wipeObject("lolContestMatches");
    cacheService.wipeObject("lolContestPlaceholders");
    cacheService.registerObject("lolContestMatches", $scope.selectedMatches);
    cacheService.registerObject("matchesModalFunction",function(tournament, match){
        searchService.get('lol/matches/' + match.id).then(function(response){
            var selectedMatches = cacheService.getObject("lolContestMatches");
            selectedMatches.push(response.data);
        });
        tournament.matches = tournament.matches.filter(function(m){return m.id !== match.id;});
    } , true);
    cacheService.registerObject("lolContestPlaceholders", $scope.selectedPlaceholders);
    cacheService.registerObject("matchPlaceholdersFunction",function(placeholder){
        var selectedPlaceholders = cacheService.getObject("lolContestPlaceholders");
        selectedPlaceholders.push(placeholder);
        placeholder.hide = true;
    } , true)


    $scope.tournaments = [];
    $scope.maximumEntriesPerUserPercent = 3;
    $scope.maximumEntriesPerUserNumber = 150;
    $scope.date = new Date();
    $scope.date.setHours(0, 0, 0, 0);


    $scope.newLoLContest = {
        contestType: "lol-daily",
        description: "My Tourney dog",
        cardImageUri: "",
        rulesUri: "rulesV1",
        streamUri: "https://www.twitch.tv/esl_lol",
        entryFee: 5,
        currency: "USD",
        entryFeeCurrency: "CASH",
        salaryCap: 100000,
        maximumEntries: 500,
        prizePool: 1000,
        minimumEntries: 2,
        pointsPerKill: 3,
        pointsPerAssist: 2,
        pointsPerDeath: -1,
        pointsPerCreepScore: 0.01,
        pointsPerTenPlusBonus: 3,
        pointsPerTripleKill: 4,
        pointsPerQuadraKill: 8,
        pointsPerPentaKill: 12,
        pointsPerTower: 1,
        pointsPerDragon: 2,
        pointsPerBaron: 3,
        pointsPerFirstBlood: 2,
        pointsPerUndefeated: 0,
        pointsPerGameWon: 2,
        shotCallerMultiplier: 1.25,
        hiddenToPublic: false,
        splits: []
    };


    $scope.save = function() {
        setStartTime();
        cacheService.registerObject("lolContest", $scope.newLoLContest);
        lolContestService.openCreateModal();
    }


    function setStartTime(){
        $scope.newLoLContest.startTime = $scope.selectedMatches[0].scheduledStartTime;
        $scope.selectedMatches.forEach(function (match) {
            if(match.scheduledStartTime < $scope.newLoLContest.startTime){
                $scope.newLoLContest.startTime = match.scheduledStartTime;
            }
        });
        console.log($scope.newLoLContest.startTime);
    }

    $scope.open = lolContestService.openMatchesModal;

    $scope.removeMatch = function(match) {
        modalService.confirm("Are you sure you'd like to remove this match?", function() {
            var selectedMatches = $scope.selectedMatches.filter(function (m) {
                return m.id != match.id;
            });
            cacheService.registerObject("lolContestMatches", selectedMatches);
            $scope.$apply();
        });
    }

    $scope.reloadData = function(){
      modalService.confirm("Are you sure you'd like to reload data for these matches?", function(){
        modalService.openLoadingModal();

        var matchIds = $scope.selectedMatches.map(function (m) {
          return m.id
        });

        searchService.post('lol/matches/reloadMatchData', {"matchIds": matchIds}, "Match data reloaded").then( function(response) {
            $scope.selectedMatches = response.data;
            modalService.closeLoadingModal();
        });
      });
    }

    $scope.removePlaceholder = function(placeholder) {
        modalService.confirm("Are you sure you'd like to remove this match?", function() {
            var selectedPlaceholders = $scope.selectedPlaceholders.filter(function (p) {
                return p.id != placeholder.id;
            });
            cacheService.registerObject("lolContestPlaceholders", selectedPlaceholders);
            $scope.$apply();
        });
    }

    $scope.openPlaceholders = lolContestService.openPlaceholdersModal;

    $scope.calculateRostersPerUser = function(){
        var data = {
            maximumEntries: $scope.newLoLContest.maximumEntries,
            maximumEntriesPerUser: $scope.newLoLContest.maximumEntriesPerUser,
            minimumEntries: $scope.newLoLContest.minimumEntries
        };
        cacheService.registerObject("maximumEntries", data);
        contestsService.openRostersCalculatorModal(function(){
            var response = cacheService.getObject("maximumEntries");
            $scope.newLoLContest.minimumEntries = response.minimumEntries;
            $scope.newLoLContest.maximumEntries = response.maximumEntries;
            $scope.newLoLContest.maximumEntriesPerUser = response.maximumEntriesPerUser;
        });
    }

    $scope.prizePoolAndSplits = function(){
        cacheService.registerObject("contest", $scope.newLoLContest);
        contestsService.openSplitsModal();
    }



    $scope.loadExchangeRates = function(){
          searchService.get('contests/exchangeRates/'+ $scope.newLoLContest.currency, {}).then( function(response) {
              $scope.newLoLContest.exchangeRates = response.data;
          });
    }

});